import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import api from '../api';
import { 
  FETCH_COMPANY,
  ON_UPDATE_COMPANY,
  ON_UPDATE_COMPANY_USER,
  ON_CREATE_COMPANY_USER,
  FETCH_COMPANY_USERS
} from 'constants/ActionTypes';
import { userSignOut } from 'actions/Auth';
import { fetchCompanySuccess, showCompanydMessage, showCompanyLoader, showBtnUpdateCompany, updateCompanySuccess, onUpdateCompanyUserSuccess, onCreateCompanyUserSuccess, fetchCompanyUsersSuccess, showCompanyUsersLoader } from 'actions/Company';

function* getCompany() {
  try {
    yield put(showCompanyLoader())
    const authToken = localStorage.getItem('token');
    const company = yield call(api.companyApi.getCompany, authToken);

    if (company.errorMessage) {
      yield put(showCompanydMessage(company.errorMessage, true));
    } else {
      yield put(fetchCompanySuccess(company));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showCompanydMessage(error.message, true));
    yield put(userSignOut());
  }
}

function* updateCompany({payload}) {
  try {
    yield put(showBtnUpdateCompany())
    const authToken = localStorage.getItem('token');
    const company = yield call(api.companyApi.updateCompany, { payload, authToken });
    
    if (company.errorMessage) {
      yield put(showCompanydMessage(company.errorMessage, true));
    } else {
      yield put(updateCompanySuccess(company));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showCompanydMessage(error.message, true));
    yield put(userSignOut());
  }
}

function* getCompanyUser() {
  try {
    yield put(showCompanyUsersLoader())
    const authToken = localStorage.getItem('token');
    const company = yield call(api.companyApi.getUsers, authToken);

    if (company.errorMessage) {
      yield put(showCompanydMessage(company.errorMessage, true));
    } else {
      yield put(fetchCompanyUsersSuccess(company));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showCompanydMessage(error.message, true));
    yield put(userSignOut());
  }
}

function* updateCompanyUser({payload}) {
  try {
    yield put(showCompanyUsersLoader())
    const authToken = localStorage.getItem('token');
    const user = yield call(api.companyApi.updateUser, { payload, authToken });
    
    if (user.errorMessage) {
      yield put(showCompanydMessage(user.errorMessage, true));
    } else {
      yield put(onUpdateCompanyUserSuccess(user));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showCompanydMessage(error.message, true));
    yield put(userSignOut());
  }
}

function* createCompanyUser({payload}) {
  try {
    yield put(showCompanyUsersLoader(payload))
    const authToken = localStorage.getItem('token');
    const user = yield call(api.companyApi.createUser, { payload, authToken });
    
    if (user.errorMessage) {
      yield put(showCompanydMessage(user.errorMessage, true));
    } else {
      yield put(onCreateCompanyUserSuccess(user));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showCompanydMessage(error.message, true));
    yield put(userSignOut());
  }
}


export function* fetchCompany() {
  yield takeEvery(FETCH_COMPANY, getCompany);
}
export function* onUpdateCompany() {
  yield takeEvery(ON_UPDATE_COMPANY, updateCompany);
}
export function* onFetchCompanyUsers() {
  yield takeEvery(FETCH_COMPANY_USERS, getCompanyUser);
}
export function* onUpdateCompanyUser() {
  yield takeEvery(ON_UPDATE_COMPANY_USER, updateCompanyUser);
}
export function* onCreateCompanyUser() {
  yield takeEvery(ON_CREATE_COMPANY_USER, createCompanyUser);
}

export default function* rootSaga() {
  yield all([
    fork(fetchCompany),
    fork(onUpdateCompany),
    fork(onCreateCompanyUser),
    fork(onUpdateCompanyUser),
    fork(onFetchCompanyUsers)
  ]);
}



// WEBPACK FOOTER //
// ./sagas/Company.js